var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"liste"}},[_c('HeaderTab',{attrs:{"title":_vm.$t('menu.actes.actes'),"swiper_tabs":_vm.swiper_tabs,"swiper_action":_vm.changeTab}}),_c('div',{attrs:{"id":"content"}},[_c('shutter-panel',{ref:"shutterPanel"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }